import React, { type SVGProps } from "react";
import { iconSizes, type IconProps } from "./utils/shared";
const PulseAiLine = (props: SVGProps<SVGSVGElement> & IconProps) => (
  <svg
    width={props.size ? iconSizes[props.size] : iconSizes["s"]}
    height={props.size ? iconSizes[props.size] : iconSizes["s"]}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    title="PulseAiLine"
    {...props}
  >
    <g id="PulseAiLine">
      <path
        id="Vector"
        d="M16.4285 6.77212L16.223 7.24352C16.0727 7.58863 15.5953 7.58863 15.4449 7.24352L15.2395 6.77212C14.8732 5.93159 14.2136 5.26237 13.3904 4.89627L12.7573 4.61472C12.4151 4.46247 12.4151 3.96437 12.7573 3.81213L13.355 3.54632C14.1993 3.17079 14.8708 2.47681 15.2307 1.60772L15.4417 1.09831C15.5888 0.743273 16.0792 0.743273 16.2262 1.09831L16.4372 1.60772C16.7972 2.47681 17.4687 3.17079 18.313 3.54632L18.9106 3.81213C19.2529 3.96437 19.2529 4.46247 18.9106 4.61472L18.2776 4.89627C17.4544 5.26237 16.7947 5.93159 16.4285 6.77212ZM12.5007 17.9475L7.50065 6.28087L5.55015 10.832H0.833984V9.16537H4.45115L7.50065 2.04989L12.5007 13.7165L14.4512 9.16537H19.1673V10.832H15.5502L12.5007 17.9475Z"
        fill="white"
      />
    </g>
  </svg>
);
export default React.memo(PulseAiLine);
